export enum WeekDays {
  Monday = "Mo",
  Tuesday = "Tu",
  Wednesday = "We",
  Thursday = "Th",
  Friday = "Fr",
  Saturday = "Sa",
  Sunday = "Su",
}

export enum WeekDaysFlags {
  None = 0,
  Monday = 1 << 0,
  Tuesday = 1 << 1,
  Wednesday = 1 << 2,
  Thursday = 1 << 3,
  Friday = 1 << 4,
  Saturday = 1 << 5,
  Sunday = 1 << 6,
}

const fromBitmask = (bitmask: WeekDaysFlags): WeekDays[] => {
  const result: WeekDays[] = [];
  if (bitmask === WeekDaysFlags.None) return result;
  if (bitmask & WeekDaysFlags.Monday) result.push(WeekDays.Monday);
  if (bitmask & WeekDaysFlags.Tuesday) result.push(WeekDays.Tuesday);
  if (bitmask & WeekDaysFlags.Wednesday) result.push(WeekDays.Wednesday);
  if (bitmask & WeekDaysFlags.Thursday) result.push(WeekDays.Thursday);
  if (bitmask & WeekDaysFlags.Friday) result.push(WeekDays.Friday);
  if (bitmask & WeekDaysFlags.Saturday) result.push(WeekDays.Saturday);
  if (bitmask & WeekDaysFlags.Sunday) result.push(WeekDays.Sunday);
  return result;
};

const toBitmask = (weekDays: WeekDays[]): WeekDaysFlags => {
  let bitmask = WeekDaysFlags.None;
  if (weekDays.length === 0) return bitmask;

  if (weekDays.includes(WeekDays.Monday)) bitmask |= WeekDaysFlags.Monday;
  if (weekDays.includes(WeekDays.Tuesday)) bitmask |= WeekDaysFlags.Tuesday;
  if (weekDays.includes(WeekDays.Wednesday)) bitmask |= WeekDaysFlags.Wednesday;
  if (weekDays.includes(WeekDays.Thursday)) bitmask |= WeekDaysFlags.Thursday;
  if (weekDays.includes(WeekDays.Friday)) bitmask |= WeekDaysFlags.Friday;
  if (weekDays.includes(WeekDays.Saturday)) bitmask |= WeekDaysFlags.Saturday;
  if (weekDays.includes(WeekDays.Sunday)) bitmask |= WeekDaysFlags.Sunday;
  return bitmask;
};

export const WeekDaysEnum = {
  fromBitmask,
  toBitmask,
};

export const sortedWeekDays = (weekDays: WeekDays[]) => {
  const weekdayOrder = Object.values(WeekDays);
  return weekDays.sort((a, b) => weekdayOrder.indexOf(a) - weekdayOrder.indexOf(b));
};
